// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root{
  margin-top: 130px;
  padding-left: 20px;
  padding-right: 20px;
  
}
 
.form-row {
  display: flex;
  gap: 16px;
}

.flex-item {
  flex: 1 1;
 
}
 
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  

  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px 15px;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none; 
    background-color: hsl(159, 100%, 51%);
    color: hsl(165, 11%, 7%);
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  


  .btndoweload {
    background-color: hsl(159, 100%, 51%); /* Green */
    color: hsl(165, 11%, 7%); /* Dark text */
    font-weight: semibold;
    padding: 5px 5px;
      size: 16px;
      height: 40px;
    border-radius: 5px;
    border: none;
    transition:  0.3s ease, transform 0.2s ease;
  }
  .btn-upload {
    background-color: transparent; /* Transparent background */
    color: hsl(159, 100%, 51%); /* Green text */
    font-weight: semibold;
    padding: 5px 5px;
    size: 16px;
    height: 40px;
    border-radius: 5px;
    border: 2px solid hsl(159, 100%, 51%); /* Green border */
    transition: 0.3s ease, transform 0.2s ease;
  }

  .btn-upload:hover {
    background-color: hsl(159, 100%, 51%); /* Green background on hover */
    color: hsl(165, 11%, 7%); /* Dark text on hover */
  }

  .btn-create {
    background-color: #1f7c50;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;
  }
  
  .btn-create:hover:enabled {
    background-color: #196b43;
    transform: translateY(-1px);
  }
  
  .btn-create:disabled {
    background-color: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
  }


  .submit-button4 {
    
    border: none;
    background-color: #ff6f61;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button4:hover {
    outline: none;
    background-color: #e65c54;
  }



  .submit-button5 {
    
    background-color: transparent;
    border: 1px solid #ff6f61;
    color: #ff6f61;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button5:hover {
    outline: none;
    background-color: #e65c54;
    color: white;
  }


  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 4px solid rgba(31, 124, 80, 0.2);
    border-top: 4px solid #1f7c50;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

.action-button,
.action-button-success,
.action-button-info,
.action-button-danger {
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
  padding: 6px;
  border-radius: 6px;
}

.action-button:hover,
.action-button-success:hover,
.action-button-info:hover,
.action-button-danger:hover {
  transform: scale(1.1);
  background-color: #f0f0f0;
}

.action-button-success:hover {
  background-color: #d4edda;
}
.action-button-info:hover {
  background-color: #d1ecf1;
}
.action-button-danger:hover {
  background-color: #f8d7da;
}


  .action-button-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

.action-button-without-border:hover {
  background-color: rgba(31, 124, 80, 0.12);
  color: #1f7c50;
}
  `, "",{"version":3,"sources":["webpack://./src/pages/AllSurveys/surveys.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;;AAET;;EAEE;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;;;EAIA;IACE,qCAAqC,EAAE,UAAU;IACjD,wBAAwB,EAAE,cAAc;IACxC,qBAAqB;IACrB,gBAAgB;MACd,UAAU;MACV,YAAY;IACd,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,6BAA6B,EAAE,2BAA2B;IAC1D,0BAA0B,EAAE,eAAe;IAC3C,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,qCAAqC,EAAE,iBAAiB;IACxD,0CAA0C;EAC5C;;EAEA;IACE,qCAAqC,EAAE,8BAA8B;IACrE,wBAAwB,EAAE,uBAAuB;EACnD;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8EAA8E;EAChF;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;;EAGA;;IAEE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;;;EAIA;;IAEE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;AAEF;;;;EAIE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,2DAA2D;EAC3D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;;EAGE;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;AAEF;EACE,yCAAyC;EACzC,cAAc;AAChB","sourcesContent":["\r\n.root{\r\n  margin-top: 130px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  \r\n}\r\n \r\n.form-row {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n.flex-item {\r\n  flex: 1;\r\n \r\n}\r\n \r\n  .table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .table th,\r\n  .table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n\r\n  \r\n  .table-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-size: 24px;\r\n    color: #333;\r\n  }\r\n  \r\n  .search-input {\r\n    width: 40%;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 12px 15px;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f3f4f6;\r\n    color: #333;\r\n  }\r\n  \r\n  .clickable-row {\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n  }\r\n  \r\n  .clickable-row:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .expanded-content {\r\n    padding: 10px;\r\n    background-color: #e9e9e9;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    text-align: center;\r\n  }\r\n  \r\n  .pagination-controls button {\r\n    padding: 8px 12px;\r\n    margin: 0 5px;\r\n    border: none; \r\n    background-color: hsl(159, 100%, 51%);\r\n    color: hsl(165, 11%, 7%);\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .pagination-controls button:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n\r\n\r\n  .btndoweload {\r\n    background-color: hsl(159, 100%, 51%); /* Green */\r\n    color: hsl(165, 11%, 7%); /* Dark text */\r\n    font-weight: semibold;\r\n    padding: 5px 5px;\r\n      size: 16px;\r\n      height: 40px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    transition:  0.3s ease, transform 0.2s ease;\r\n  }\r\n  .btn-upload {\r\n    background-color: transparent; /* Transparent background */\r\n    color: hsl(159, 100%, 51%); /* Green text */\r\n    font-weight: semibold;\r\n    padding: 5px 5px;\r\n    size: 16px;\r\n    height: 40px;\r\n    border-radius: 5px;\r\n    border: 2px solid hsl(159, 100%, 51%); /* Green border */\r\n    transition: 0.3s ease, transform 0.2s ease;\r\n  }\r\n\r\n  .btn-upload:hover {\r\n    background-color: hsl(159, 100%, 51%); /* Green background on hover */\r\n    color: hsl(165, 11%, 7%); /* Dark text on hover */\r\n  }\r\n\r\n  .btn-create {\r\n    background-color: #1f7c50;\r\n    color: #fff;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    padding: 8px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;\r\n  }\r\n  \r\n  .btn-create:hover:enabled {\r\n    background-color: #196b43;\r\n    transform: translateY(-1px);\r\n  }\r\n  \r\n  .btn-create:disabled {\r\n    background-color: #e0e0e0;\r\n    color: #999;\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n  }\r\n\r\n\r\n  .submit-button4 {\r\n    \r\n    border: none;\r\n    background-color: #ff6f61;\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    height: 30px !important;\r\n  }\r\n  \r\n  .submit-button4:hover {\r\n    outline: none;\r\n    background-color: #e65c54;\r\n  }\r\n\r\n\r\n\r\n  .submit-button5 {\r\n    \r\n    background-color: transparent;\r\n    border: 1px solid #ff6f61;\r\n    color: #ff6f61;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    height: 30px !important;\r\n  }\r\n  \r\n  .submit-button5:hover {\r\n    outline: none;\r\n    background-color: #e65c54;\r\n    color: white;\r\n  }\r\n\r\n\r\n  .loading-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    z-index: 9999;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .spinner {\r\n    border: 4px solid rgba(31, 124, 80, 0.2);\r\n    border-top: 4px solid #1f7c50;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n\r\n.action-button,\r\n.action-button-success,\r\n.action-button-info,\r\n.action-button-danger {\r\n  border: none;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, background-color 0.2s ease;\r\n  padding: 6px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.action-button:hover,\r\n.action-button-success:hover,\r\n.action-button-info:hover,\r\n.action-button-danger:hover {\r\n  transform: scale(1.1);\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.action-button-success:hover {\r\n  background-color: #d4edda;\r\n}\r\n.action-button-info:hover {\r\n  background-color: #d1ecf1;\r\n}\r\n.action-button-danger:hover {\r\n  background-color: #f8d7da;\r\n}\r\n\r\n\r\n  .action-button-without-border{\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n    border: none; \r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n.action-button-without-border:hover {\r\n  background-color: rgba(31, 124, 80, 0.12);\r\n  color: #1f7c50;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
